// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown--OA4_r","dropdown__input-stub":"dropdown__input-stub--l5VcG","dropdown__list":"dropdown__list--_hxN2","static":"static--EorPp"};